import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

import imgMarker from 'src/assets/images/map/marker.svg';

const GroupMarker = ({ onClick, count, active }) => {
  const handleClick = () => {
    onClick()
  }
  
  return (
    <Root onClick={handleClick}>
      <Marker active={active}>
        <span>{count}</span>
      </Marker>
    </Root>
  );
};

GroupMarker.propTypes = {
  onClick: PropTypes.func,
  group: PropTypes.object,
  count: PropTypes.number,
  active: PropTypes.bool,
};

GroupMarker.defaultProps = {
  onClick: f => f,
  group: {},
  count: 0,
  active: false,
}

const Root = styled.div`
  position: relative;
`;

const animateMarker = keyframes`
  to {
    transform: rotate(360deg);
  }
`

const Marker = styled.div`
  width: 57px;
  height: 57px;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  transform: translateX(-50%) translateY(-50%) translateZ(0) ${props => props.active ? 'scale(0.25)' : 'scale(1)'};
  opacity: ${props => props.active ? '0' : '1'};
  pointer-events: ${props => props.active ? 'none' : 'auto'};
  transition: opacity 0.5s, transform 0.5s;
  &:hover {
    &:before {
      animation: ${animateMarker} linear 10s infinite;
    }
  }
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url(${imgMarker});
    background-size: cover;
    transform: rotate(0deg);
  }
  span {
    width: 48px;
    height: 48px;
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    color: #fff;
    font-size: 32px;
  }
`

export default GroupMarker;



// WEBPACK FOOTER //
// ./src/components/Map/elements/GroupMarker.js